import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import UserSlice from './Slices/UserSlice';
import WikiSlice from './Slices/WikiSlice';
import WikiPageSlice from './Slices/WikiPageSlice';

export const store = configureStore({
  reducer: {
    user: UserSlice,
    wiki: WikiSlice,
    wikiPage: WikiPageSlice
  }
});
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export const useMountEffect = (fun: { (): void }): void => useEffect(fun, [fun]);
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;